"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsBase = require("@telus-uds/components-base");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _utils = require("../../../../utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const [selectProps, selectedSystemPropTypes] = (0, _componentsBase.selectSystemProps)([_utils.htmlAttrs]);
const StyledButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "VideoButton__StyledButton",
  componentId: "components-web__sc-kfw0tr-0"
})(_ref => {
  let {
    color
  } = _ref;
  return {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'stretch',
    'svg path': {
      fill: color
    }
  };
});
const VideoButton = _ref2 => {
  let {
    icon,
    label,
    disableFocus,
    children,
    tokens,
    variant,
    ...rest
  } = _ref2;
  const {
    color
  } = (0, _componentsBase.useThemeTokens)('VideoButton', tokens, variant);
  const handleOnKeyDown = event => {
    const key = event.key || event.keyCode;

    // Disables playing by space bar, as that can be used to click a button
    if (key === ' ' || key === 32) {
      event.stopPropagation();
    }
  };
  const handleClick = event => {
    event.preventDefault();
    rest.onClick?.(event);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButton, {
    "aria-label": label,
    onKeyDown: handleOnKeyDown,
    tabIndex: disableFocus ? '-1' : undefined,
    color: color,
    ...selectProps(rest),
    onClick: handleClick,
    children: [icon, children]
  });
};
VideoButton.propTypes = {
  ...selectedSystemPropTypes,
  icon: _propTypes.default.element.isRequired,
  label: _propTypes.default.string.isRequired,
  disableFocus: _propTypes.default.bool.isRequired,
  children: _propTypes.default.node
};
var _default = exports.default = VideoButton;